import React from 'react';

import { Modifier, EditorState } from 'draft-js';
// import createEmojiPlugin from '@draft-js-plugins/emoji';
import createEmojiPlugin from 'draft-js-emoji-plugin';
import { baseTheme } from 'themes/clients/baseTheme';

import { Emoji } from 'assets/assetsV1/iconComponents';

import { getEntitiesByLogic } from 'services/helpers/post';

import { Button } from 'uiToolkitV1/Button';

import emojiStyles from './EmojiStyles.module.css';

const EmojiIcon = () => <Emoji fill="transparent" />;

export function deleteMentionEntity({ mentionId, editorState }) {
  let contentState = editorState.getCurrentContent();
  const entities = getEntitiesByLogic({
    editorState,
    findEntity: ({ type, mention }) => type === 'mention' && mention.employee.id === mentionId,
  });
  if (entities.length === 0) {
    return;
  }
  const selectionState = editorState.getSelection();
  const entitySelection = selectionState.merge({
    anchorOffset: entities[0].start,
    focusOffset: entities[0].end,
  });
  contentState = Modifier.applyEntity(contentState, entitySelection, null);
  const newContentState = Modifier.replaceText(contentState, entitySelection, '');
  const newEditorState = EditorState.createWithContent(newContentState);
  return newEditorState;
}

export function createNewEmojiPlugin({ size, iconSize = 'tinierFixed' }) {
  const newEmojiStyles = {
    ...emojiStyles,
    emojiSelect: `${emojiStyles.emojiSelect} ${size === 'small' && ' emojiSelectSizeSmall'}`,
  };
  // if (size === 'small') {
  //   newEmojiStyles = {
  //     ...emojiStyles,
  //     emojiSelect: +' '
  //   };
  // }
  return createEmojiPlugin({
    selectButtonContent: (
      <Button
        sx={{
          svg: {
            color: `${baseTheme.colors.text.g2} !important`,
          },
        }}
        variant="tertiary"
        StartIcon={EmojiIcon}
      />
    ),
    // useNativeArt: true,
    theme: newEmojiStyles,
  });
  // this.EmojiSuggestions = emojiPlugin.EmojiSuggestions;
  // this.EmojiSelect = emojiPlugin.EmojiSelect;
}
